import React, { useState } from 'react';
import '../styles/Benevole.css';
import { createBenevole } from '../services/api';

function Benevole() {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    ville: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await createBenevole(formData);

      if (response.success) {
        setSubmitted(true);
        console.log('✅ Candidature envoyée:', response.data);

        setTimeout(() => {
          setSubmitted(false);
          setFormData({
            nom: '',
            prenom: '',
            email: '',
            telephone: '',
            ville: '',
          });
        }, 5000);
      }
    } catch (error) {
      console.error('❌ Erreur:', error);
      alert('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="benevole-container">
      {/* Header */}
      <div className="benevole-header">
        <h1>Devenir Bénévole</h1>
        <p className="header-subtitle">
          Rejoignez notre équipe et contribuez au développement des Comores
        </p>
      </div>

      <div className="benevole-content">
        {/* Info Section */}
        <section className="info-section">
          <div className="container">
            <h2>Pourquoi devenir bénévole ?</h2>
            <div className="avantages-grid">
              <div className="avantage-card">
                <div className="avantage-icon">🤝</div>
                <h3>Impact Réel</h3>
                <p>Participez à des projets concrets qui changent des vies</p>
              </div>
              
              <div className="avantage-card">
                <div className="avantage-icon">🌍</div>
                <h3>Expérience Enrichissante</h3>
                <p>Découvrez une culture unique et développez vos compétences</p>
              </div>
              
              <div className="avantage-card">
                <div className="avantage-icon">👥</div>
                <h3>Communauté Solidaire</h3>
                <p>Intégrez une famille engagée et passionnée</p>
              </div>
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="form-section">
          <div className="container">
            <div className="form-wrapper">
              <h2>Formulaire d'inscription</h2>
              <p className="form-description">
                Remplissez ce formulaire pour rejoindre notre équipe de bénévoles
              </p>

              {submitted && (
                <div className="success-message">
                  ✓ Merci ! Votre demande a été envoyée avec succès. Nous vous contacterons bientôt.
                </div>
              )}

              <form onSubmit={handleSubmit} className="benevole-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nom">Nom *</label>
                    <input
                      type="text"
                      id="nom"
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                      required
                      placeholder="Votre nom"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="prenom">Prénom *</label>
                    <input
                      type="text"
                      id="prenom"
                      name="prenom"
                      value={formData.prenom}
                      onChange={handleChange}
                      required
                      placeholder="Votre prénom"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="votre.email@exemple.com"
                    />
                  </div>


                  <div className="form-group">
                    <label htmlFor="telephone">Téléphone *</label>
                    <input
                      type="tel"
                      id="telephone"
                      name="telephone"
                      value={formData.telephone}
                      onChange={handleChange}
                      required
                      placeholder="06 12 34 56 78"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="ville">Ville *</label>
                  <input
                    type="text"
                    id="ville"
                    name="ville"
                    value={formData.ville}
                    onChange={handleChange}
                    required
                    placeholder="Votre ville"
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Envoyer
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <h2>Des questions ?</h2>
            <p>N'hésitez pas à nous contacter pour plus d'informations</p>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <span>asifc.rhone@gmail.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Rhône-Alpes, France</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Benevole;